import NotifySong from "../../assets/notify.wav";
import { telemetry } from "../telemetry/telemetry";

interface PlayOptions {
  callId?: string;
}

interface AudioHealth {
  unlocked: boolean;
  lastSuccessAgeMs: number | null;
  consecutiveFailures: number;
}

const RETRY_DELAY_MS = 200;
const TYPICAL_AUDIO_DURATION_MS = 3_000;

let lastPlayStartedAt: number | null = null;

async function attemptPlay(callId: string | undefined, attempt: number): Promise<boolean> {
  // Cria um Audio novo por chamada (sem singleton compartilhado).
  // Browsers fazem GC do elemento depois que ele termina.
  lastPlayStartedAt = Date.now();
  const a = new Audio(NotifySong);
  a.preload = "auto";
  try {
    const result = a.play();
    if (result && typeof result.then === "function") {
      await result;
    }
    telemetry("audio_ok", { callId, attempt });
    return true;
  } catch (err: any) {
    const name = err?.name || "UnknownError";
    if (name === "NotAllowedError") {
      telemetry("autoplay_blocked", { callId, attempt });
    }
    if (attempt < 2) {
      await new Promise((r) => setTimeout(r, RETRY_DELAY_MS));
      return attemptPlay(callId, attempt + 1);
    }
    telemetry("audio_failed", {
      callId,
      attempts: attempt,
      name,
      message: err?.message,
    });
    return false;
  }
}

export async function playNotify(opts: PlayOptions = {}): Promise<boolean> {
  return attemptPlay(opts.callId, 1);
}

// Stubs preservados para compatibilidade com PanelContext.tsx e __panelDebug.
// Sem singleton, nao ha mais estado de saude para reportar — sempre saudavel.
export function getHealth(): AudioHealth {
  return { unlocked: true, lastSuccessAgeMs: 0, consecutiveFailures: 0 };
}

export function isHealthy(): boolean {
  return true;
}

// Indica se um playNotify foi disparado recentemente. Usado pelo
// PanelContext para nao reloadar a pagina enquanto o notify.wav ainda
// pode estar tocando. Auto-corretivo apos TYPICAL_AUDIO_DURATION_MS.
export function isAudioActive(): boolean {
  if (lastPlayStartedAt === null) return false;
  return Date.now() - lastPlayStartedAt < TYPICAL_AUDIO_DURATION_MS;
}
